import type { RouteRecordRaw } from 'vue-router'

const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: 'UserList',
    component: () => import('./views/UserListPage.vue'),
    meta: {
      title: 'users.Users',
      layout: 'default',
      requiresAuth: true
    }
  },
  // 기존 users/invite 경로 리다이렉트 (하위 호환성)
  {
    path: '/users/invite',
    redirect: '/users'
  }
]

export default usersRoutes
